import { useEffect, useState } from "react";

import { browserShareDevice, canShareSheet, shareLink } from "@/lib/shareLink";

interface CopyLinkButtonProps {
  /** A path and query, worked out when clicked so it holds the current moment. */
  getLink: () => string;
}

const COPIED_MS = 1_500;

export function CopyLinkButton({ getLink }: CopyLinkButtonProps) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!copied) {
      return undefined;
    }
    const timer = setTimeout(() => setCopied(false), COPIED_MS);
    return () => clearTimeout(timer);
  }, [copied]);

  const copy = async (): Promise<void> => {
    const link = `${window.location.origin}${getLink()}`;
    try {
      const result = await shareLink(link, document.title, browserShareDevice());
      setCopied(result === "copied");
    } catch {
      window.prompt("Copy this link", link);
    }
  };

  const idle = canShareSheet(browserShareDevice())
    ? "Share this moment"
    : "Copy link to this moment";

  return (
    <button
      type="button"
      className="timeline-options__copy-link"
      onClick={() => {
        void copy();
      }}
    >
      {copied ? "Link copied" : idle}
    </button>
  );
}
